<template>
  <div class="workload-page">
    <el-form class="search-head" :inline="true" label-position="left">
      <el-form-item label="操作">
        <el-select v-model="form.type" placeholder="请选择" clearable>
          <el-option
            v-for="item in operation"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker
          v-model="form.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item label="患者姓名">
        <el-input v-model="form.patientName" />
      </el-form-item>
      <el-form-item label="审核项目">
        <el-input v-model="form.checkItem" />
      </el-form-item>
      <el-form-item label="所属阶段">
        <el-input v-model="form.phase" />
      </el-form-item>

      <el-form-item class="search-group">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="reload">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="tabel-box">
      <el-table
        v-loading="listLoading"
        stripe
        style="width:100%"
        border
        :data="tableData"
      >
        <el-table-column label="分类">
          <template slot-scope="scope">
            <p v-if="scope.row.objType == 10">组</p>
            <p v-if="scope.row.objType == 20">文件</p>
          </template>
        </el-table-column>
        <el-table-column prop="objId" label="编号" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <p>{{ getType(scope.row.type) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            <p>
              {{
                scope.row.updateTime
                  | convertTime('YYYY-MM-DD HH:mm:ss')
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="patientName"
          label="患者姓名"
        />
        <el-table-column
          prop="checkItem"
          label="审核项目"
        />
        <el-table-column label="所属阶段">
          <template slot-scope="scope">
            <p v-if="scope.row.phase">
              {{ '第' + scope.row.phase + '阶段' }}
            </p>
            <p v-else>
              <span v-if="scope.row.phase === 0">无阶段</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.fileGroupId"
              type="text"
              size="small"
              @click="watch(scope.row)"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="button-handle">
        <el-button
          type="primary"
          :loading="downloadLoading"
          @click="handleDownload"
        >导出当前页</el-button>

        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.pageIndex"
          :limit.sync="listQuery.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { logpage, detailPage } from '@/api/work'
import { projectquery } from '@/api/user'
import Pagination from '@/components/Pagination'
import Moment from 'moment'
export default {
  inject: ['reload'],
  components: { Pagination },
  data() {
    return {
      listLoading: false,
      firstSearch: null,
      downloadLoading: false,
      listQuery: {
        pageIndex: 1,
        pageSize: 20
      },
      form: {
        type: null,
        patientName: null,
        checkItem: null,
        phase: null,
        date: null
      },
      total: 0,
      operation: [
        {
          label: '上传文件',
          value: 10
        },
        {
          label: '编辑材料',
          value: 20
        },
        {
          label: '删除文件',
          value: 30
        },
        {
          label: '指定患者',
          value: 40
        },
        {
          label: '上传文件组',
          value: 50
        }
      ],
      tableData: [],
      accountId: null,
      projectId: null
    }
  },
  created() {
    this.accountId = this.$route.params.accountId
    this.projectId = this.$route.params.projectId
    this.firstSearch = {
      accountId: this.accountId,
      projectId: this.projectId,
      type: null,
      patientName: null,
      checkItem: null,
      phase: null,
      begTime: null,
      endTime: null,
      pageIndex: 1,
      pageSize: 20
    }
    this.initData(this.firstSearch)
  },
  methods: {
    // 获取 操作类型
    getType(data) {
      switch (data) {
        case 10:
          return '上传文件'
          break
        case 20:
          return '编辑材料'
          break
        case 30:
          return '删除材料'
          break
        case 40:
          return '指定患者'
          break
        case 50:
          return '上传文件组'
          break
      }
    },
    initData(data) {
      this.listLoading = true
      detailPage(data).then(res => {
        this.tableData = res.data.records
        this.total = res.data.total
        setTimeout(() => {
          this.listLoading = false
        }, 100)
      })
    },
    getList() {
      this.firstSearch.pageIndex = this.listQuery.pageIndex
      this.firstSearch.pageSize = this.listQuery.pageSize
      this.initData(this.firstSearch)
    },
    search() {
      this.firstSearch.type = this.form.type
      this.firstSearch.patientName = this.form.patientName
        ? this.form.patientName.trim()
        : null
      this.firstSearch.checkItem = this.form.checkItem
        ? this.form.checkItem.trim()
        : null
      this.firstSearch.phase = this.form.phase
      this.firstSearch.begTime = this.form.date
        ? this.form.date[0].getTime()
        : null
      this.firstSearch.endTime = this.form.date
        ? this.form.date[1].getTime()
        : null
      this.listQuery.pageIndex = 1
      this.initData(this.firstSearch)
    },
    // 查看
    watch(row) {
      if (row.fileGroupId) {
        this.$router.push({
          name: 'materialwatch',
          params: { id: row.fileGroupId }
        })
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          console.log('h', j)
          if (j === 'objType') {
            var a
            v[j] == 10 ? (a = '组') : (a = '文件')
            return a
          } else if (j === 'type') {
            return this.getType(v[j])
          } else if (j == 'updateTime') {
            return Moment(v[j]).format('YYYY-MM-DD HH:mm:ss')
          } else if (j === 'phase') {
            if (v[j]) {
              return '第' + v[j] + '阶段'
            } else {
              if (v[j] == 0) {
                return '无阶段'
              } else {
                return ''
              }
            }
          } else {
            return v[j]
          }
        })
      )
    },
    handleDownload() {
      this.downloadLoading = true
			import('./table').then(excel => {
			  const tHeader = [
			    '分类',
			    '编号',
			    '操作',
			    '时间',
			    '患者姓名',
			    '审核项目',
			    '所属阶段'
			  ]
			  const filterVal = [
			    'objType',
			    'objId',
			    'type',
			    'updateTime',
			    'patientName',
			    'checkItem',
			    'phase'
			  ]
			  const data = this.formatJson(filterVal, this.tableData)
			  excel.export_json_to_excel({
			    header: tHeader,
			    data,
			    filename: '工作量统计'
			  })
			  this.downloadLoading = false
			})
    }
  }
}
</script>

<style lang="scss" scoped>
.workload-page {
	.search-head {
		padding: 0 30px;
	}
	.tabel-box {
		padding: 20px 30px;
	}
}
@media (max-width: 1920px) {
	.search-group {
		float: right;
		margin-right: 100px;
	}
}
@media (max-width: 992px) {
	.search-group {
		float: right;
		margin-right: 120px;
	}
}
@media (max-width: 768px) {
	.search-group {
		float: left;
	}
}
</style>
<style lang="scss">
.button-handle {
	margin-top: 30px;
	display: flex;
	align-items: center;
	.pagination-container {
		margin-top: 0px;
	}
}
</style>
